import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Mail, Send, ArrowRight } from "lucide-react";

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Trigger email with subscription request
      const subject = encodeURIComponent("Newsletter Subscription Request");
      const body = encodeURIComponent(
        `I would like to subscribe to the IQ Hub newsletter.\n\nEmail: ${email}`
      );
      window.location.href = `mailto:support@iq-hub.com?subject=${subject}&body=${body}`;
      setEmail("");
    }
  };

  return (
    <section id="contact" className="py-24 bg-[#0F172A] relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#C8A951]/5 blur-[150px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8">
        {/* Get in Touch — Primary CTA */}
        <div className="text-center mb-16">
          <span className="text-[#C8A951] text-sm font-semibold tracking-[0.15em] uppercase mb-4 block">
            Let's Connect
          </span>
          <h2 className="text-3xl lg:text-5xl font-bold text-white tracking-tight mb-4">
            Let's Connect
          </h2>
          <p className="text-lg text-[#94A3B8] mb-8 max-w-xl mx-auto">
            Whether you're looking to attend, speak, exhibit, or partner — we'd love to hear from you.
          </p>

          <a href="mailto:support@iq-hub.com">
            <Button className="bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold text-lg px-10 py-7 rounded-lg group">
              <Mail className="w-5 h-5 mr-3" />
              support@iq-hub.com
              <ArrowRight className="w-5 h-5 ml-3 group-hover:translate-x-1 transition-transform" />
            </Button>
          </a>

          <p className="text-sm text-[#64748B] mt-4">
            Or call us: <a href="tel:+12065820128" className="text-[#C8A951] hover:underline">+1 206-582-0128</a> (U.S.)
            {" · "}
            <a href="tel:+6531584211" className="text-[#C8A951] hover:underline">+65 3158-4211</a> (Singapore)
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-14">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-xs text-[#64748B] uppercase tracking-wider">Or subscribe to our newsletter</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        {/* Newsletter */}
        <div className="text-center">
          <h3 className="text-xl font-bold text-white mb-2">
            Never Miss an Update
          </h3>
          <p className="text-sm text-[#94A3B8] mb-6 max-w-md mx-auto">
            Join our mailing list for the latest news and industry insights.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          >
            <div className="flex-1">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-white/5 border-white/10 text-white placeholder:text-[#64748B] h-12 px-5 rounded-lg focus:border-[#C8A951] focus:ring-[#C8A951]/20"
              />
            </div>
            <Button
              type="submit"
              className="bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold h-12 px-6 rounded-lg group"
            >
              Subscribe
              <Send className="w-4 h-4 ml-2 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Button>
          </form>

          <p className="text-xs text-[#475569] mt-4">
            No spam, ever. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};
